module.exports = __webpack_public_path__ + "static/media/transition2.37d151c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/Conviot/Develope/img/transition2.png
// module id = 203
// module chunks = 0